import { padPx } from '@/css-helpers/units'
import { disabledGray, hoverBlue, linkBlue } from '@/refactor/colors'
import styled from '@/styles'

const SelectorButton = styled.button<{ selected: boolean; width?: number | string }>`
	border-radius: 10px;
	text-align: left;
	border: ${({ selected: $selected }) => ($selected ? 2 : 1)}px solid
		${({ selected: $selected }) => ($selected ? linkBlue : disabledGray)};
	padding: ${({ selected: $selected }) => ($selected ? 9 : 10)}px;
	transition: all 150ms ease-in-out;
	cursor: pointer;
	background: white;
	${({ width: $width }) => ($width !== undefined ? `width: ${padPx($width)};` : '')}

	&:hover {
		background: ${hoverBlue};
		border-color: ${linkBlue};
	}
`

export default SelectorButton
